import request from '@/utils/request_cn';

//获取店铺列表枚举
export function getVendorList(needChildVendorFlag) {
  return request({
    url: `/sc-merchant-common/v2/vendor/list/nameBox/excludeSeller/regionFilter`,
    method: 'post',
    data: {
      needChildVendorFlag,
    },
  });
}

//获取所有系统枚举
export function getSystemList() {
  return request({
    url: `/basic-backend/boutique/system/list`,
    method: "get",
  });
}

//获取所有店铺类型列表
export function getVendorType() {
  return request({
    url: `/basic-backend/boutique/enum/vendorType`,
    method: "get",
  });
}

//获取所有国家列表
export function getCountryList() {
  return request({
    url: `/basic-backend/address/country/list`,
    method: "get",
  });
}

//protal列表枚举
export function getUserTypeList() {
  return request({
    url: `/basic-backend/boutique/enum/userType`,
    method: "get",
  });
}

//买手店详情
export function getBoutiqueInformation(vendorId) {
  return request({
    url: `/basic-backend/boutique/information/${vendorId}`,
    method: "get",
  });
}

//修改密码
export function resetPassword(data, vendorId) {
  return request({
    url: `/user-center/user/password/${vendorId}`,
    method: "post",
    data,
  });
}

//商品接入方式枚举
export function getProductSourceTypeList() {
  return request({
    url: `/basic-backend/boutique/enum/productSourceType`,
    method: "get",
  });
}

//库存类型枚举
export function getStockTypeList() {
  return request({
    url: `/basic-backend/boutique/enum/stockType`,
    method: "get",
  });
}

//价格对接方式枚举
export function getSupplyPriceMethodList() {
  return request({
    url: `/basic-backend/boutique/enum/supplyPriceMethod`,
    method: "get",
  });
}

//供货价是否含税枚举
export function getBoutiquePriceTaxList() {
  return request({
    url: `/basic-backend/boutique/enum/boutiquePriceTax`,
    method: "get",
  });
}

//吊牌价是否含税枚举
export function getVendorRetailPriceTaxList() {
  return request({
    url: `/basic-backend/boutique/enum/vendorRetailPriceTax`,
    method: "get",
  });
}

//货币单位枚举
export function getUnitList() {
  return request({
    url: `/basic-backend/price/unit/list`,
    method: "get",
  });
}

//创建买手店
export function createBoutique(data) {
  return request({
    url: `/basic-backend/boutique/create`,
    method: "post",
    data,
  });
}

//编辑买手店
export function updateBoutique(data, vendorId) {
  return request({
    url: `/basic-backend/boutique/update/${vendorId}`,
    method: "post",
    data,
  });
}

//获取店铺状态
export function getVendorStatusList() {
  return request({
    url: `/basic-backend/boutique/enum/vendorStatus`,
    method: "get",
  });
}

//修改店铺状态
export function updateOperationStatus(vendorId, value, data = {}) { //value=4为休假中的时候 传data
  return request({
    url: `/basic-backend/boutique/status/operation/${vendorId}/${value}`,
    method: "post",
    data,
  });
}

//获取业务区域列表
export function getBusinessRegionList() {
  return request({
    url: `/basic-backend/business/region/list`,
    method: "get",
  });
}

//获取订单通知项
export function getBoutiqueOrderStatus() {
  return request({
    url: `/basic-backend/boutique/enum/apiOrderStatus`,
    method: "get",
  });
}


//
export function getMerchantVendorList() {
  return request({
    url: `/basic-backend/boutique/list/merchant/vendor`,
    method: "get",
  });
}

export function getVendorStockLocation(vendorId) {
  return request({
    url: `/basic-backend/stock/location/list?vendorId=${vendorId}`,
    method: "get",
  });
}

export function getMerchantList(data) {
  return request({
    url: `/sc-basic-merchant-backend/stockLocation/list`,
    method: "post",
    data,
  });
}

export function createAccount(data) {
  return request({
    url: `/sc-basic-merchant-backend/stockLocation/create/account`,
    method: "post",
    data,
  });
}

export function editAccount(data) {
  return request({
    url: `/sc-basic-merchant-backend/stockLocation/account/edit`,
    method: "post",
    data,
  });
}

export function stopAccount(data) {
  return request({
    url: `/sc-basic-merchant-backend/stockLocation/stop/account`,
    method: "post",
    data,
  });
}

export function enabledAccount(data) {
  return request({
    url: `/sc-basic-merchant-backend/stockLocation/enabled/account`,
    method: "post",
    data,
  });
}

export function resetAccount(data) {
  return request({
    url: `/sc-basic-merchant-backend/stockLocation/reset/account`,
    method: "post",
    data,
  });
}
export function updateStockLocationCategory(params) {
  return request({
    url: `/sc-basic-merchant-backend/stockLocation/update/category`,
    method: "post",
    params,
  });
}

export async function vendorAreaListLevelOne() { //区域一级列表
  return (await request({
    url: `/basic-backend/spu/split/config/groups?channelId=1`,
    method: 'get'
  })).data;
}

export async function getUserList() { //商务运营列表
  return (await request({
    url: `/basic-backend/boutique/getUserList`,
    method: 'get',
  })).data;
}
///update/assistantInfo
export async function updateAssistantInfo(id,data) { //商务运营列表
  return (await request({
    url: `/basic-backend/boutique/update/assistantInfo/${id}`,
    method: 'post',
    data
  })).data;
}
export async function getXiaJiTongBuList(data) { //3.获取“下集货单店铺”&“同步库存店铺” 下拉框
  return (await request({
    url: `/sc-basic-merchant-backend/crm/vendor/list/byVendorType`,
    method: 'post',
    data,
  })).data;
}

export function createVendorSystem(data) {
  return request({
    url: `/basic-backend/boutique/createVendorSystem`,
    method: 'post',
    data,
  });
}

export function updateVendorSystem(data) {
  return request({
    url: `/basic-backend/boutique/updateVendorSystem`,
    method: 'post',
    data,
  });
}

export function deleteVendorSystem(params) {
  return request({
    url: `/basic-backend/boutique/deleteVendorSystem`,
    params,
  });
}

export function getListVendorSystem(params) {
  return request({
    url: `/basic-backend/boutique/listVendorSystem`,
    params,
  });
}

export function getInvoiceDetail(params) {
  return request({
    url: `/sc-basic-merchant-backend/invoice/list`,
    params
  });
}

export function getBoutiqueCountryList() {
  return request({
    url: `/sc-basic-merchant-backend/country/list`,
  });
}

export function getBoutiqueCityList(params) {
  return request({
    url: `/sc-basic-merchant-backend/country/city/list`,
    params
  });
}

export function saveOrUpdateInvoice(data) {
  return request({
    url: `/sc-basic-merchant-backend/invoice/saveOrUpdate`,
    method: 'post',
    data,
  });
}

export function getTermsList() {
  return request({
    url: `/sc-basic-merchant-backend/terms/list`,
  });
}

export function getPaymentWay(params) {
  return request({
    url: `/sc-basic-merchant-backend/paymentWay/list`,
    params,
  });
}

export function saveOrUpdatePaymentWay(data) {
  return request({
    url: `/sc-basic-merchant-backend/paymentWay/saveOrUpdate`,
    method: 'post',
    data,
  });
}

export function queryStockLocation(params) {
  return request({
    url: `/sc-basic-merchant-backend/stockLocation/queryStockLocation`,
    params,
  });
}

export function openOrCancelStockLocation(params) {
  return request({
    url: `/sc-basic-merchant-backend/stockLocation/openOrCancelStockLocation`,
    params,
  });
}

export function createStockLocation(data) {
  return request({
    url: `/sc-basic-merchant-backend/stockLocation/createStockLocation`,
    method: 'post',
    data,
  });
}

export function updateStockLocation(data) {
  return request({
    url: `/sc-basic-merchant-backend/stockLocation/updateStockLocation`,
    method: 'post',
    data,
  });
}

export function getBoutiqueAftermarketEmailList(params) {
  return request({
    url: `/sc-basic-merchant-backend/vendorConfiguration/getBoutiqueAftermarketEmailList`,
    params,
  });
}

export function addBoutiqueAftermarketEmail(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendorConfiguration/addBoutiqueAftermarketEmail`,
    method: 'post',
    data,
  });
}

export function delBoutiqueAftermarketEmail(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendorConfiguration/delBoutiqueAftermarketEmail`,
    method: 'post',
    data,
  });
}

export function getConfigUpdateList(params) {
  return request({
    url: `/sc-basic-merchant-backend/taskManage/getConfigUpdateList`,
    params,
  });
}

export function getTaskCodeList() {
  return request({
    url: `/sc-basic-merchant-backend/taskManage/getTaskCodeList`,
  });
}


export function queryEmailConfigurationByVendorId(params) {
  return request({
    url: `/basic-backend/performance/property/queryEmailConfigurationByVendorId`,
    params,
  });
}

export function saveEmailDefectLevelConfiguration(data) {
  return request({
    url: `/basic-backend/performance/property/saveEmailDefectLevelConfiguration`,
    method: 'post',
    data,
  });
}

export function getDockingInfo(params) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/manager/interface/info`,
    params,
  });
}

export function saveDockingInfo(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/manager/interface/create`,
    method: 'post',
    data,
  });
}

export function getBuyerLevelList(data) {
  return request({
    url: `/sc-basic-merchant-backend/buyer/level/list`,
    method: 'post',
    data,
  });
}

export function getBuyerList() {
  return request({
    url: `/sc-basic-merchant-backend/buyer/list`,
  });
}

export function setBuyerLevel(data) {
  return request({
    url: `/sc-basic-merchant-backend/buyer/level/edit`,
    method: 'post',
    data,
  });
}

export function getVendorAndStockLocationList(params) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/manager/stockLocation/list`,
    params,
  });
}
//getSearchAliaList
export async function getSearchAliaList() {
  return (await request({
    url: `/sc-basic-merchant-backend/vendorConfiguration/listAlias`,
    method: 'get',
  })).data;
}


//运营类型 枚举接口：/boutique/enum/vendorOperationType
export async function vendorOperationType() {
  return (await request({
    url: `/basic-backend/boutique/enum/vendorOperationType`,
    method: 'get',
  })).data;
}

export async function vendorExemptionChannel() {
  return (await request({
    url: `/sc-basic-merchant-backend/vendor/exemption/channel`,
    method: 'get',
  })).data;
}

export async function vendorExemptionPage(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/vendor/exemption/page`,
    method: 'post',
    data,
  })).data;
}

export async function saveVendorExemption(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/vendor/exemption/save`,
    method: 'post',
    data,
  })).data;
}

export async function updateVendorExemption(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/vendor/exemption/update`,
    method: 'post',
    data,
  })).data;
}

export async function delVendorExemption(params) {
  return (await request({
    url: `/sc-basic-merchant-backend/vendor/exemption/del`,
    method: 'get',
    params,
  })).data;
}

export async function vendorAfterSaleWhiteList(params) {
  return (await request({
    url: `/sc-basic-merchant-backend/vendor/afterSale/whitelist/page`,
    method: 'get',
    params,
  })).data;
}

export async function addVendorAfterSaleWhiteList(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/vendor/afterSale/whitelist/add`,
    method: 'post',
    data,
  })).data;
}

export async function updateVendorAfterSaleWhiteList(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/vendor/afterSale/whitelist/update`,
    method: 'post',
    data,
  })).data;
}

export async function getRelationVendorList() {
  return (await request({
    url: `/sc-basic-merchant-backend/stock/vendor/relation/list/vendor`,
  })).data;
}

export async function getVendorRelationList() {
  return (await request({
    url: `/sc-basic-merchant-backend/stock/vendor/relation/list`,
  })).data;
}

export async function saveVendorRelationList(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/stock/vendor/relation/save/or/update`,
    method: 'post',
    data,
  })).data;
}

export async function deleteVendorRelation(params) {
  return (await request({
    url: `/sc-basic-merchant-backend/stock/vendor/relation/delete`,
    params,
  })).data;
}

export async function getVendorProductConfigList(params) {
  return (await request({
    url: `/sc-basic-merchant-backend/vendor/im/product/config/page`,
    params,
  })).data;
}

export async function updateVendorProductConfig(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/vendor/im/product/config/update`,
    method: 'post',
    data,
  })).data;
}

export async function addVendorProductConfig(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/vendor/im/product/config/add`,
    method: 'post',
    data,
  })).data;
}

export async function deleteVendorProductConfig(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/vendor/im/product/config/delete`,
    method: 'post',
    data,
  })).data;
}

export async function getSeasonCodes() {
  return (await request({
    url: `/sc-basic-merchant-backend/vendor/im/product/config/getSeasonCodes`,
  })).data;
}

export async function getPoolVendorList() {
  return (await request({
    url: `/sc-basic-merchant-backend/vendor/im/product/config/getVendors`,
  })).data;
}

export async function saveOrUpdateRelation(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/stock/vendor/relation/v2/save/or/update`,
    method: 'post',
    data
  })).data;
}

export async function getRelationList() {
  return (await request({
    url: `/sc-basic-merchant-backend/stock/vendor/relation/v2/list`,
  })).data;
}

export async function deleteRelation(params) {
  return (await request({
    url: `/sc-basic-merchant-backend/stock/vendor/relation/v2/delete`,
    params
  })).data;
}
